import Loader from "react-loader-spinner";
import { useHistory } from 'react-router-dom';
import { useEffect, useRef, useState } from "react";
import { addOrUpdateStage, getStage, getStageList, getStageTypes, getEntityStatusList, deleteStage, getUserList } from "../store/api/FlowAPI";
import { Table, Modal, Button, Row, Popover, OverlayTrigger, Form, FormGroup, Alert } from 'react-bootstrap';
import { useDispatch, useSelector } from "react-redux";
import { Bookmark, BookmarkCheck, CheckLg, ExclamationTriangle, Person, Trash } from 'react-bootstrap-icons';
import { setDialog, setErrorDialog } from "../../store/api/CommonFunctions";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faRedo, faThList, faTimes } from "@fortawesome/free-solid-svg-icons";
import BihamtaMultiSelect from "../../Components/BihamtaMultiSelect";

const ModalFlowStages = () => {
    const history = useHistory();
    const [currentStage, setCurrentStage] = useState({});
    const [statusList, setStatusList] = useState([]);
    const [stageList, setStageList] = useState([]);
    const [userList, setUserList] = useState([]);
    const rowBtnClicked = useRef(false);
    const { stageTypes } = useSelector(state => { return { stageTypes: state.FlowData.stageTypes } })
    const dispatch = useDispatch();
    const [submitError, setSubmitError] = useState(null);

    const close = () => {
        history.goBack();
    }
    const stageRowClick = (e, stage) => {
        if (rowBtnClicked.current) {
            rowBtnClicked.current = false;
            return;
        }
        e.currentTarget.parentElement.querySelectorAll(".resultTableRow").forEach(el => {
            el.classList.remove("selectedResultTableRow");
        });
        e.currentTarget.classList.add("selectedResultTableRow");
        const onGet = (res) => {
            if (res.Data) {
                setCurrentStage(res.Data);
            }
        }
        getStage(stage.ID, onGet);

    }
    const addEditStage = () => {
        setSubmitError(null);
        if (!currentStage.EntityType || currentStage.EntityType === '') {
            setSubmitError("نوع مرحله را مشخص کنید.");
            return;
        }
        if (!currentStage.StageName || currentStage.StageName === '') {
            setSubmitError("نام مرحله را وارد کنید.");
            return;
        }
        if (!(currentStage.UserList?.length > 0)) {
            setSubmitError("فهرست کاربران خالی است.");
            return;
        }
        if (!(currentStage.StatusList?.length > 0)) {
            setSubmitError("فهرست وضعیت های مجاز خالی است");
            return;
        }
        if (!(currentStage.EntryStatusList?.length > 0)) {
            setSubmitError("فهرست وضعیت های ممکن خالی است.");
            return;
        }
        const onSuccess = (res) => {

            if (res.Error) {
                setSubmitError(res.Error);
                return;
            }
            if (res.Data) {
                setErrorDialog(dispatch, "success", "مراحل کاری");
                const table = document.getElementById("tblFlow");
                table.querySelectorAll(".resultTableRow").forEach(el => {
                    el.classList.remove("selectedResultTableRow");
                });
                if (!currentStage.ID) {
                    const lstStage = stageList.slice();
                    currentStage.ID = res.Data;
                    const stg = { ...currentStage };
                    lstStage.push(stg);
                    setStageList(lstStage);
                }
                setCurrentStage({ EntityType: currentStage.EntityType });
            }
        }
        addOrUpdateStage(currentStage, onSuccess);
    }
    const onDeleteStage = (id) => {
        const lstStage = stageList.filter(s => s.ID !== id);
        setStageList(lstStage);
    }
    const onStageTypeChange = (value) => {
        setCurrentStage({ EntityType: value });
        setStageList("PENDING");
        setStatusList("PENDING");
        const onSuccess = (list) => {
            setStageList(list);
        }
        dispatch(getStageList(value, onSuccess));
        const onSuccessStatus = (list) => {
            setStatusList(list);
        }
        getEntityStatusList(value, onSuccessStatus);
    }
    function delStage(id) {
        rowBtnClicked.current = true;
        dispatch(setDialog({
            status: 'show',
            arrayBtn: ['yes', 'no'],
            dialogTitle: 'حذف مرحله کاری',
            dialogText: 'آیا از حذف مطمئن هستید؟',
            okOperation: deleteStage(id, onDeleteStage)
        }))
    }
    function onCheckUser(e, id) {
        if (!currentStage.UserList) {
            currentStage.UserList = [];
        }
        if (e.target.checked) {
            currentStage.UserList.push(id);
        }
        else {
            currentStage.UserList = currentStage.UserList.filter(s => Number(s) !== Number(id));
        }
        setCurrentStage({ ...currentStage });
    }
    function onStatusChecked(e, id) {
        if (!currentStage.StatusList) {
            currentStage.StatusList = [];
        }
        if (e.target.checked) {
            currentStage.StatusList.push({ StatusID: id });
        }
        else {
            currentStage.StatusList = currentStage.StatusList.filter(s => Number(s.StatusID) !== Number(id));
        }
        setCurrentStage({ ...currentStage });
    }
    function onFinishChecked(e, id) {
        if (!currentStage.StatusList) {
            return;
        }
        const foundSt = currentStage.StatusList.find(s => Number(s.StatusID) === Number(id));
        if (!foundSt) {
            return;
        }
        foundSt.IsFinishingStatus = e.target.checked;
        setCurrentStage({ ...currentStage });
    }
    function onUserSelect(user, id) {
        if (!currentStage.StatusList) {
            return;
        }
        const foundSt = currentStage.StatusList.find(s => Number(s.StatusID) === Number(id));
        if (!foundSt) {
            return;
        }
        //برای پیش گیری از رندرهای اضافی
        if (Number(foundSt.NextUserID) !== Number(user.value)) {
            foundSt.NextUserID = user.value;
            setCurrentStage({ ...currentStage });
        }
        //
    }
    function checkAllUser(e) {
        if (e.target.checked) {
            setCurrentStage({ ...currentStage, UserList: userList.map(u => u.ID) });
        }
        else {
            setCurrentStage({ ...currentStage, UserList: [] });
        }
    }
    function checkAllStatus(e) {
        if (e.target.checked) {
            setCurrentStage({ ...currentStage, StatusList: statusList.map(s => s.ID) });
        }
        else {
            setCurrentStage({ ...currentStage, StatusList: [] });
        }
    }
    function checkAllEntryStatus(e) {
        if (e.target.checked) {
            setCurrentStage({ ...currentStage, EntryStatusList: statusList.map(s => s.ID) });
        }
        else {
            setCurrentStage({ ...currentStage, EntryStatusList: [] });
        }
    }
    function onEntryStatusChecked(e, id) {
        if (!currentStage.EntryStatusList) {
            currentStage.EntryStatusList = [];
        }
        if (e.target.checked) {
            currentStage.EntryStatusList.push(id);
        }
        else {
            currentStage.EntryStatusList = currentStage.EntryStatusList.filter(s => Number(s) !== Number(id));
        }
        setCurrentStage({ ...currentStage });
    }
    const popStatusList = (
        <Popover id="popStatusList" style={{ fontFamily: "Vazir", minWidth: "500px" }} show={true}>
            <Popover.Title className="headerStyle"><BookmarkCheck size={18} />&nbsp;وضعیت های مجاز</Popover.Title>
            <Popover.Content className="bodyStyle">
                <div className="scThin" style={{ overflow: "auto", maxHeight: "190px" }}>

                    <Table className="mb-0 designedTable" style={{ "--rowColor": "#c4ebebcc" }}>
                        <thead style={{ backgroundColor: "#268e9f" }}>
                            <tr>
                                <th style={{ position: "sticky", top: 0, backgroundColor: "#268e9f" }}>
                                    <input type="checkbox" className="form-check-input" onChange={checkAllStatus} />
                                </th>
                                <th style={{ position: "sticky", top: 0, backgroundColor: "#268e9f", zIndex: 100 }}>وضعیت</th>
                                <th style={{ position: "sticky", top: 0, backgroundColor: "#268e9f", zIndex: 100 }}>وضعیت نهایی</th>
                                <th style={{ position: "sticky", top: 0, backgroundColor: "#268e9f", zIndex: 100 }}>کاربر بعدی</th>
                            </tr>
                        </thead>
                        <tbody>
                            {Array.isArray(statusList ?? "") &&
                                statusList.map((st, i) => <tr key={i}>
                                    <td><input type="checkbox" className="form-check-input" checked={currentStage.StatusList?.some(s => Number(s.StatusID) === Number(st.ID))} onChange={e => onStatusChecked(e, st.ID)} /></td>
                                    <td>{st.Status}</td>
                                    <td><input type="checkbox" className="form-check-input" checked={currentStage.StatusList?.some(s => Number(s.StatusID) === Number(st.ID) && s.IsFinishingStatus?.toString() === "true")} onChange={e => onFinishChecked(e, st.ID)} /></td>
                                    <td>
                                        <BihamtaMultiSelect dataSource={userList} valueItem="ID" displayItem="Name" inputClassName="tableRowInput" selectOne onItemCheckChanged={(item) => onUserSelect(item, st.ID)}
                                            defaultCheckedList={currentStage.StatusList?.find(s => Number(s.StatusID) === Number(st.ID))?.NextUserID ? [currentStage.StatusList?.find(s => Number(s.StatusID) === Number(st.ID))?.NextUserID?.toString()] : null} />
                                    </td>

                                </tr>)
                            }
                        </tbody>
                    </Table>
                </div>
            </Popover.Content>
        </Popover>
    )
    const popEntryStatusList = (
        <Popover style={{ fontFamily: "Vazir", minWidth: "300px" }}>
            <Popover.Title className="headerStyle"><Bookmark size={18} /> وضعیت های ورودی</Popover.Title>
            <Popover.Content className="bodyStyle">
                <div className="scThin" style={{ overflow: "auto", maxHeight: "190px" }}>
                    <Table className="mb-0 designedTable" style={{ "--rowColor": "#bed2eb" }}>
                        <thead style={{ backgroundColor: "#5683c7" }}>
                            <tr>
                                <th style={{ paddingTop: "4px", paddingBottom: "4px", position: "sticky", top: 0, backgroundColor: "#5683c7" }}>
                                    <input type="checkbox" className="form-check-input" onChange={checkAllEntryStatus} />

                                </th>
                                <th style={{ paddingTop: "4px", paddingBottom: "4px", position: "sticky", top: 0, backgroundColor: "#5683c7" }}>وضعیت</th>
                            </tr>
                        </thead>
                        <tbody>
                            {Array.isArray(statusList ?? "") &&
                                statusList.map((st, i) => <tr key={i}>
                                    <td><input type="checkbox" className="form-check-input" checked={currentStage.EntryStatusList?.includes(st.ID)} onChange={e => onEntryStatusChecked(e, st.ID)} /></td>
                                    <td>{st.Status}</td>
                                </tr>)
                            }
                        </tbody>
                    </Table>
                </div>
            </Popover.Content>
        </Popover>
    )
    const popUserList = (
        <Popover style={{ minWidth: "300px", fontFamily: "Vazir" }}>
            <Popover.Title className="headerStyle"><Person size={18} />&nbsp;فهرست کاربران مجاز</Popover.Title>
            <Popover.Content className="bodyStyle">
                <div className="scThin" style={{ overflow: "auto", maxHeight: "190px" }}>
                    <Table className="designedTable mb-0" style={{ "--rowColor": "#b4bdc791" }}>
                        <thead style={{ backgroundColor: "#b4bdc7" }}>
                            <tr>
                                <th style={{ position: "sticky", paddingTop: "4px", paddingBottom: "4px", top: 0, backgroundColor: "#b4bdc7" }}>
                                    <input type="checkbox" className="form-check-input" onChange={checkAllUser} />
                                </th>
                                <th style={{ position: "sticky", paddingTop: "4px", paddingBottom: "4px", top: 0, backgroundColor: "#b4bdc7" }}>نام کاربر</th>
                            </tr>
                        </thead>
                        <tbody>
                            {Array.isArray(userList) &&
                                userList.map((user, i) =>
                                    <tr key={i}>
                                        <td>
                                            <input type="checkbox" className="form-check-input" checked={currentStage.UserList?.includes(user.ID)} onChange={e => onCheckUser(e, user.ID)} />
                                        </td>
                                        <td>{user.Name}</td>
                                    </tr>)}
                        </tbody>
                    </Table>
                </div>
            </Popover.Content>
        </Popover>
    )
    useEffect(() => {
        dispatch(getStageTypes());
        getUserList("", setUserList);
    }, []);
    return (
        <Modal show={true} size="lg" style={{ direction: "rtl" }} onHide={() => { }}>
            <Modal.Header className="headerStyle"><span><FontAwesomeIcon icon={faThList} size="lg" /> مدیریت مراحل کاری</span><FontAwesomeIcon icon={faTimes} size="lg" onClick={close} /></Modal.Header>
            <Modal.Body className="bodyStyle">
                <Row>
                    <div className="rowBorder scThin col-md-6">
                        <div className="rowTitle">مراحل کاری</div>
                        <div className="form-group">
                            <select className="tableRowInput scThin" onChange={e => onStageTypeChange(e.target.value)} style={{ width: "80%" }}>
                                <option value="">نوع مرحله را انتخاب کنید</option>
                                {stageTypes && Array.isArray(stageTypes) &&
                                    stageTypes.map((item, i) => <option key={i} value={item.Item1}>{item.Item2}</option>)
                                }
                            </select>
                        </div>
                        <Table responsive className="fixedTable mt-2" id="tblFlow">
                            <thead>
                                <tr>
                                    <th style={{ width: "40%" }}>نام مرحله</th>
                                    <th style={{ width: "40%" }}>شرح مرحله</th>
                                    <th style={{ width: "20%" }}>&nbsp;</th>
                                </tr>
                            </thead>
                            <tbody>
                                {(stageList === "PENDING") &&
                                    <tr>
                                        <td colSpan={3} style={{ textAlign: "center", width: "100%" }}>
                                            <Loader type="BallTriangle" color="rgb(228, 3, 117)" height={20} width={20} />
                                        </td>
                                    </tr>
                                }
                                {stageList && Array.isArray(stageList) &&
                                    stageList.map((item, i) =>
                                        <tr key={i} className="resultTableRow" onClick={(e) => stageRowClick(e, item)}>
                                            <td style={{ width: "40%" }}>{item.StageName}</td>
                                            <td style={{ width: "40%" }}>{item.StageDesc ?? "--"}</td>
                                            <td style={{ width: "20%" }}>
                                                <Trash className="rowBtn" color="red" size={16}
                                                    onClick={() => delStage(item.ID)} />
                                            </td>
                                        </tr>
                                    )
                                }
                            </tbody>
                        </Table>
                    </div>
                    {currentStage.EntityType?.length > 1 &&
                        <div className="col-md-6 scThin rowBorder">
                            <div className="rowTitle">
                                اطلاعات مرحله
                                {currentStage.EntityType?.length > 1 &&
                                    <FontAwesomeIcon icon={faRedo} size="lg" color="#189f76" title="بازنشانی فرم" onClick={() => setCurrentStage({ EntityType: currentStage.EntityType })} style={{ cursor: "pointer", marginRight: "5px" }} />
                                }
                            </div>
                            <Row>
                                <FormGroup className="col-md-7">
                                    <label>نام مرحله:</label>
                                    <Form.Control value={currentStage?.StageName ?? ""} onChange={e => setCurrentStage({ ...currentStage, StageName: e.target.value })} />
                                </FormGroup>
                                <FormGroup className="col-md-5">
                                    <label>شماره مرحله:</label>
                                    <Form.Control type="number" value={currentStage?.StageOrder ?? ""} onChange={e => setCurrentStage({ ...currentStage, StageOrder: e.target.value })} />
                                </FormGroup>
                            </Row>
                            <FormGroup className="mt-1">
                                <label>وضعیت رد ارجاع:</label>
                                <select className="form-control" value={currentStage.RejectStatusID ?? ""} onChange={e => setCurrentStage({ ...currentStage, RejectStatusID: e.target.value })}>
                                    <option value="">انتخاب کنید</option>
                                    {Array.isArray(statusList) &&
                                        statusList.map((st, i) => <option key={i} value={st.ID}>{st.Status}</option>)
                                    }
                                </select>
                            </FormGroup>
                            <div style={{ display: "flex", justifyContent: "space-between" }}>
                                <OverlayTrigger overlay={popUserList} trigger="click" rootClose placement="left">
                                    <Button className="group-Btn mt-1" variant="secondary" style={{margin:"auto"}}><Person size={16} />&nbsp;کاربران مجاز</Button>
                                </OverlayTrigger>
                                <OverlayTrigger overlay={popStatusList} trigger="click" rootClose placement="bottom">
                                    <Button className="group-Btn mt-1" variant="info"  style={{margin:"auto"}}><BookmarkCheck size={16} />&nbsp;وضعیت های مجاز</Button>
                                </OverlayTrigger>
                                <OverlayTrigger overlay={popEntryStatusList} trigger="click" rootClose placement="left">
                                    <Button className="group-Btn mt-1"  style={{margin:"auto"}}><Bookmark size={16} />&nbsp;وضعیت های ورودی</Button>
                                </OverlayTrigger>
                            </div>
                            <Row style={{ margin: 0 }}>
                                <Button variant="success" className="group-Btn-large mt-2 " style={{ margin: "auto" }} onClick={addEditStage}><CheckLg size={18} />&nbsp;ثبت تغییرات</Button>
                            </Row>
                            {submitError && <Alert variant="danger" className="mt-2">
                                <ExclamationTriangle size={19} />&nbsp;
                                {submitError}
                                <FontAwesomeIcon icon={faTimes} size="lg" onClick={() => setSubmitError(null)} style={{ float: "left" }} />
                            </Alert>}
                        </div>
                    }
                </Row>
            </Modal.Body>
        </Modal>
    )
}
export default ModalFlowStages;